import React from 'react';
import AdvisoryProps from '../interfaces/AdvisoryProps';

const AdvisoryRetire: React.FC<AdvisoryProps> = ({ packageName, advisory }) => {

    const urlList = (advisory.url_list) ? advisory.url_list.map((url, key) => {
        return <li key={key}><a href={url} key={key} target="_blank" rel="noreferrer">{url}</a></li>;
    }) : [];

    return (
        <div>
            <h4>{packageName}</h4>
            <ul>
                <li>Title : {advisory.title}</li>
                <li>CVE : {advisory.cves ? advisory.cves.join(";") : ''}</li>
                <li>Severity : {advisory.severity}</li>
                <li>Affected Versions : {advisory.vulnerable_versions}</li>
                <li>File : {advisory.file}</li>
                <li>Link : <ul>{urlList}</ul></li>
            </ul>
        </div>
    );
}

export default AdvisoryRetire;